import { QrCodeActions } from "@swiggy-private/portal-dineout-context";
import type { IPinVerificationCardData } from "@swiggy-private/portal-dineout-context";

import type { IParentOrderMetadata, IPinDataResponse } from "../types";

interface StashSkippedPinArgs {
    /** The `data` field of a 155 (PIN_GENERATION_SKIPPED) response. */
    responseData: IPinDataResponse | null | undefined;
    dispatch: (action: { type: QrCodeActions; payload: { data: IParentOrderMetadata } }) => void;
    setPinVerificationCardData?: (data: IPinVerificationCardData | null) => void;
}

/**
 * Handles the pin payload carried by a 155 (PIN_GENERATION_SKIPPED) response, shared by the
 * create-order (usePlaceOrder) and track-page (useGetOrders) flows.
 *
 * V2 skips the pin API, so the 155 response is the only source of the secondary user's
 * table/host. We stash it in pin state now so the single post-verify pin sync carries
 * table/host to native (for its analytics).
 */
export const stashSkippedPinDetails = ({
    responseData,
    dispatch,
    setPinVerificationCardData,
}: StashSkippedPinArgs): void => {
    const pinDetails = responseData?.pinData;
    if (!pinDetails) return;
    dispatch({ type: QrCodeActions.PIN_GENERATION_SUCCESS, payload: { data: pinDetails } });
    setPinVerificationCardData?.({
        title: "",
        description: "",
        hostName: pinDetails.hostName,
    });
};
